import { postForm } from 'ovpn-ui-toolkit';

/**
 * Saves a file with given name and content.
 *
 * Posts a form to node.js endpoint (which is a legacy approach but known to work best).
 *
 * User Blob with FileReader on iOS-Chrome
 */
export function saveProfile(name: string, profile: string, formPostURL = '/download-profile/') {
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);

    if (isChromeIOS) {
        const blob = new Blob([profile], {
            type: 'application/x-openvpn-profile',
        });

        const reader = new FileReader();
        reader.onloadend = () => {
            const a = document.createElement('a');
            a.href = reader.result as string;
            a.style.display = 'none';
            a.download = name;
            document.body.appendChild(a);
            a.click();
            a.parentNode?.removeChild(a);
        };
        reader.readAsDataURL(blob);
    } else {
        postForm(formPostURL, {
            name,
            certificate: profile,
        });
    }
}
